<template>
  <Breadcrumbs main="Eventos" title="Mis Eventos" />
  <div class="container-fluid">
    <CardsTotal v-if="eventsLoaded" :events="events" />
    <dashboardMyEvents v-if="eventsLoaded" :events="eventsInbox3" />
    <div v-else class="text-center py-5">
      <span class="spinner-border text-primary" role="status"></span>
      <div class="mt-2">Cargando eventos...</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "@/includes/connection";
import CardsTotal from "./projectlist/CardsTotal.vue";
import dashboardMyEvents from "./projectlist/dashboardMyEvents.vue";

const events = ref([]);
const eventsInbox3 = ref([]);
const eventsLoaded = ref(false);

onMounted(() => {
  loadItems();
});

function loadItems() {
  axios
    .get(`/event/userEvents`)
    .then((response) => {
      events.value = response.data;
      eventsInbox3.value = events.value.filter((ev) => ev.inbox === 3);
      eventsLoaded.value = true;
    })
    .catch(function (error) {
      events.value = [];
      eventsInbox3.value = [];
      eventsLoaded.value = true;
      console.log(error);
    });
}
</script>
